export default {
    images: [],
    image: {}
  }